import React, { useState } from "react";

const YT_CHANNEL = "https://youtube.com/@gareebokafilmmaker";
const GIF = "https://media.tenor.com/01fHdcawbZMAAAAj/youtube-new-post.gif";

export default function SupportBadge() {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;
  return (
    <a
      href={YT_CHANNEL}
      target="_blank"
      rel="noreferrer"
      data-testid="support-creator-badge"
      className="fixed bottom-4 right-4 z-50 group inline-flex items-center gap-2.5 pl-2 pr-4 py-2 rounded-full bg-black/90 backdrop-blur-xl border border-red-500/40 shadow-[0_0_24px_rgba(255,77,57,0.35)] hover:shadow-[0_0_40px_rgba(255,77,57,0.6)] hover:border-red-500/70 transition-all"
    >
      <img
        src={GIF}
        alt=""
        className="w-9 h-9 rounded-full object-cover ring-2 ring-red-500/60"
        aria-hidden
      />
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-red-400">
          @gareebokafilmmaker
        </span>
        <span className="text-sm font-medium text-white">
          Support the creator <span aria-hidden>✨</span>
        </span>
      </span>
      <button
        type="button"
        data-testid="support-badge-close"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setHidden(true);
        }}
        className="ml-1 w-5 h-5 rounded-full bg-white/5 hover:bg-white/15 text-zinc-400 hover:text-white text-xs leading-none flex items-center justify-center"
        aria-label="Dismiss"
      >
        ×
      </button>
    </a>
  );
}
